// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';
import {selx} from 'clsx';

import {SvgIconEl} from 'common/components/svg-icon';
import {TooltipEl} from 'common/components/tooltip';

import type {InputLabel} from './index';
import styles from './index.module.styl';

export function template(this: InputLabel) {
  return (
    <div sel={selx(styles.mpInputLabelContainer)}>
      <label sel={selx(styles.mpInputLabel)} attrs={{for: this.attr(`field-id`)}}>
        {this.attr(`label`)}
      </label>
      {this.attr(`necessary`) ? <span sel={selx(styles.mpInputNecessary)}>{this.attr(`necessary`)}</span> : null}
      {this.attr(`help-text`) ? (
        <div sel={selx(styles.mpInputHelpIcon)}>
          <SvgIconEl attrs={{icon: `info`}} />
          <TooltipEl attrs={{'max-width': `500px`, 'text-align': this.attr(`help-text-align`)}}>
            {this.attr(`help-text`)}
          </TooltipEl>
        </div>
      ) : null}
      {this.attr(`extra-info`) ? <div sel={selx(styles.mpInputExtraInfo)}>{this.attr(`extra-info`)}</div> : null}
    </div>
  );
}
